import * as _ from "lodash";


export function jsonEscape(str) {
    return str.replace(/\n/g, "\\\\n").replace(/\r/g, "\\\\r").replace(/\t/g, "\\\\t");
}

export function jsonEscapeRemove(str) {
    return str.replace(/\n/g, "").replace(/\r/g, "").replace(/\t/g, "");
}

export function isOfType(v): 'NUMBER' | 'STRING' | 'BOOLEAN' {
    if (_.isNumber(v)) return 'NUMBER';
    if (v === 'true' || v === 'false' || v === true || v === false) return 'BOOLEAN';
    if (v === '') return 'STRING';
    if (_.isString(String(v))) return 'STRING';
}

export function convertFormat(type, v) {
    if (type === 'NUMBER') {
        v = _.toNumber(v);
        return isNaN(v) ? 0 : v;
    } else if (type === 'BOOLEAN') {
        return String(v) === 'true';
    } else {
        return String(v);
    }
}

export function jsonToBase64(val: {}) {
    if (isNullOrUndefOrEmpty(val)) return '';
    return btoa(JSON.stringify(val));
}

export function base64ToJson(val: string) {
    if (isNullOrUndefOrEmpty(val)) return {};
    const c = atob(val);
    return JSON.parse(c);
}

export function isBase64(i_value): boolean {
    try {
        return btoa(atob(i_value)) === i_value;
    } catch (e) {
        return false;
    }
}

export function convertNumberToBoolean(val) {
    return Boolean(Number(val));
}

export function convertBooleanToNumbers(values, convertToString: boolean = false, clone: boolean = false): object | number | string {
    if (values instanceof Object) {
        if (clone) values = _.cloneDeep(values);
        Object.keys(values).forEach((key) => {
            if (values[key] === 'true' || values[key] === true) {
                values[key] = convertToString ? '1' : 1;
            }
            if (values[key] === 'false' || values[key] === false) {
                values[key] = convertToString ? '0' : 0;
            }
        });
        return values;
    } else {
        if (values === 'true' || values === true) {
            return convertToString ? '1' : 1;
        }
        if (values === 'false' || values === false) {
            return convertToString ? '0' : 0;
        }
        return values;
    }
}

export function isFalsy(v): boolean {
    if (v === false) return true;
    if (v === 'false') return true;
    if (v === '0') return true;
    if (v === 0) return true;
    return false;
}

export function isTruthy(v): boolean {
    if (v === true) return true;
    if (v === 'true') return true;
    if (v === '1') return true;
    if (v === 1) return true;
    return false;
}

export function roundNumber(value, cnt: number = 0) {
    return Math.round(parseFloat(value) * Math.pow(10, cnt)) / Math.pow(10, cnt);
}

/**
 * format bytes
 * @param bytes (File size in bytes)
 * @param decimals (Decimals point)
 */
 export function formatBytes(bytes, decimals): string {
    if (bytes === 0) {
        return '0 Byte';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}


export function isNoValue(i_value) {
    if (i_value === '-1') return true;
    if (i_value === -1) return true;
    if (_.isEmpty(i_value)) return true;
    if (_.isUndefined(i_value)) return true;
    if (_.isNaN(i_value)) return true;
    if (_.isNull(i_value)) return true;
}

export function isBooleanString(i_value) {
    if (i_value === true || i_value === 'true' || i_value === false || i_value === 'false') {
        return true;
    }
    return false;
}

// const f5 = isDigit('123');
// const f6 = isDigit(123);
// const f7 = isDigit(-1);
// const f8 = isDigit(0);
// const f9 = isDigit('0');
// const f10 = isDigit('0.1');
// const f11 = isDigit(0.1);
// const f12 = isDigit(-0.1);
// const f13 = isDigit(1);
// const f1 = isDigit('');
// const f2 = isDigit('   ');
// const f3 = isDigit(undefined);
// const f4 = isDigit(null);
// const f14 = isDigit('null');
// const f15 = isDigit('undefined');
// const f16 = isDigit('NULL');
// const f17 = isDigit('UNDEFINED');
// const f19 = isDigit({});
// const f20 = isDigit(NaN);
export function isDigitNoEmpty(i_value): boolean {
    if (_.isString(i_value) && i_value.trim() === '') return false;
    if (_.isNull(i_value)) return false;
    if (_.isUndefined(i_value)) return false;
    const value = Number(i_value);
    return !_.isNaN(value);
}

export function isDigit(i_value): boolean {
    if (_.isNull(i_value)) return false;
    if (_.isUndefined(i_value)) return false;
    const value = Number(i_value);
    return !_.isNaN(value);
}

// const a1 = isBlankString('');
// const a2 = isBlankString('   ');
// const a3 = isBlankString(undefined);
// const a4 = isBlankString(null);
// const a5 = isBlankString('123');
// const a6 = isBlankString(123);
// const a7 = isBlankString(-1);
// const a8 = isBlankString(0);
// const a9 = isBlankString('0');
// const a10 = isBlankString('0.1');
// const a11 = isBlankString(0.1);
// const a12 = isBlankString(-0.1);
// const a13 = isBlankString(1);
// const a14 = isBlankString('null');
// const a15 = isBlankString('undefined');
// const a16 = isBlankString('NULL');
// const a17 = isBlankString('UNDEFINED');
// const a18 = isBlankString({});
// const a19 = isBlankString(NaN);
export function isBlankString(i_value): boolean {
    if (!_.isString(i_value)) return true;
    return _.isEmpty(i_value.trim());
}


// const c3 = isNullOrUndef(undefined);
// const c4 = isNullOrUndef(null);
// const c1 = isNullOrUndef('');
// const c2 = isNullOrUndef('   ');
// const c5 = isNullOrUndef('123');
// const c6 = isNullOrUndef(123);
// const c7 = isNullOrUndef(-1);
// const c8 = isNullOrUndef(0);
// const c9 = isNullOrUndef('0');
// const c10 = isNullOrUndef('0.1');
// const c11 = isNullOrUndef(0.1);
// const c12 = isNullOrUndef(-0.1);
// const c13 = isNullOrUndef(1);
// const c14 = isNullOrUndef('null');
// const c15 = isNullOrUndef('undefined');
// const c16 = isNullOrUndef('NULL');
// const c17 = isNullOrUndef('UNDEFINED');
// const c19 = isNullOrUndef({});
// const c20 = isNullOrUndef(NaN);
export function isNullOrUndef(i_value): boolean {
    if (_.isNumber(i_value)) return false;
    return (_.isNull(i_value) || _.isUndefined(i_value));
}


// const b1 = isNullOrUndefOrEmpty('');
// const b2 = isNullOrUndefOrEmpty('   ');
// const b3 = isNullOrUndefOrEmpty(undefined);
// const b4 = isNullOrUndefOrEmpty(null);
// const b5 = isNullOrUndefOrEmpty('123');
// const b6 = isNullOrUndefOrEmpty(123);
// const b7 = isNullOrUndefOrEmpty(-1);
// const b8 = isNullOrUndefOrEmpty(0);
// const b9 = isNullOrUndefOrEmpty('0');
// const b10 = isNullOrUndefOrEmpty('0.1');
// const b11 = isNullOrUndefOrEmpty(0.1);
// const b12 = isNullOrUndefOrEmpty(-0.1);
// const b13 = isNullOrUndefOrEmpty(1);
// const b14 = isNullOrUndefOrEmpty('null');
// const b15 = isNullOrUndefOrEmpty('undefined');
// const b16 = isNullOrUndefOrEmpty('NULL');
// const b17 = isNullOrUndefOrEmpty('UNDEFINED');
// const b18 = isNullOrUndefOrEmpty({});
// const b19 = isNullOrUndefOrEmpty(NaN);
export function isNullOrUndefOrEmpty(i_value): boolean {
    if (_.isNull(i_value)) return true;
    if (_.isUndefined(i_value)) return true;
    if (i_value === 'undefined' || i_value === 'UNDEFINED' || i_value === 'null' || i_value === 'NULL') return true;
    if (i_value === '0' || i_value === 0) return false;
    if (_.isString(i_value) && i_value.trim() === '') return true;
    return false;
}

// const d1 = isStringNullOrUndefOrEmpty('');
// const d2 = isStringNullOrUndefOrEmpty('   ');
// const d3 = isStringNullOrUndefOrEmpty(undefined);
// const d4 = isStringNullOrUndefOrEmpty(null);
// const d14 = isStringNullOrUndefOrEmpty('null');
// const d15 = isStringNullOrUndefOrEmpty('undefined');
// const d16 = isStringNullOrUndefOrEmpty('NULL');
// const d17 = isStringNullOrUndefOrEmpty('UNDEFINED');
// const d5 = isStringNullOrUndefOrEmpty('123');
// const d6 = isStringNullOrUndefOrEmpty(123);
// const d7 = isStringNullOrUndefOrEmpty(-1);
// const d8 = isStringNullOrUndefOrEmpty(0);
// const d9 = isStringNullOrUndefOrEmpty('0');
// const d10 = isStringNullOrUndefOrEmpty('0.1');
// const d11 = isStringNullOrUndefOrEmpty(0.1);
// const d12 = isStringNullOrUndefOrEmpty(-0.1);
// const d13 = isStringNullOrUndefOrEmpty(1);
// const d19 = isStringNullOrUndefOrEmpty({});
// const d20 = isStringNullOrUndefOrEmpty(NaN);
export function isStringNullOrUndefOrEmpty(i_value): boolean {
    if (_.isObject(i_value)) return false;
    if (_.isNaN(i_value)) return false;
    if (_.isNumber(i_value)) return false;
    if (_.isString(i_value) && i_value.trim().toLowerCase() === 'undefined') return true;
    if (_.isString(i_value) && i_value.trim().toLowerCase() === 'null') return true;
    if (_.isString(i_value) && i_value.trim() === '') return true;
    return (_.isNull(i_value) || _.isUndefined(i_value) || _.isEmpty(i_value));
}

export function toCurrency(value, params = []) {
    value = parseFloat(value);
    const symbol = params[0] === 'eu' ? '\u20AC' : '$';
    const decimal = !isNullOrUndef(params[1]) ? params[1] : 2;
    return symbol + value.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

export function toPercent(value) {
    return +parseFloat(value).toFixed(2) + '%';
}
